import EventBus from "./event-bus";
import {errorHandler} from "./utils";

const axios = require('axios');

export function getVendorList() {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'merchant/vendors', {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        EventBus.$emit("showLoading", false);
        resolve(response['data'])
      })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}

export function placeVendorOrder(order) {
  return new Promise(function(resolve, reject) {
    console.log("place order ");
    console.log(order);
    axios.post(process.env.ROOT_API + 'merchant/vendor/order',  JSON.stringify(order), {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    })
      .then(response => resolve(response['data']))
      .catch(error => {
        errorHandler(error);
        reject(error)
      });
  })
}

export function sendVendorOrder(id) {
  return new Promise(function(resolve, reject) {
    console.log("place order " + localStorage.getItem("JSTOKEN"));
    axios.get(process.env.ROOT_API + 'merchant/vendor/order/send?id='+id, {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        let data = response['data']
        // if(data.success)
          resolve(data)
        // else
        //   reject(data.message)
      })
      .catch(error => {
        errorHandler(error);
        reject(error);

      });
  })
}
export function getDeliveryDates() {
  return new Promise(function(resolve, reject) {
    console.log("place order " + localStorage.getItem("JSTOKEN"));
    axios.get(process.env.ROOT_API + 'merchant/deliveryDates', {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        let data = response['data']
        if(data.success)
          resolve(data)
        else
          reject(data.message)
      })
      .catch(error => {
        errorHandler(error);
        reject(error)
      });
  })
}



// WEBPACK FOOTER //
// ./src/api/vendor.js